export const testimonials = [
  {
    id: 1,
    quote:
      '"Datapixl played a key role in bringing our AI-driven tabletop gaming vision to life. They built a scalable system for generating immersive game assets while ensuring cost efficiency and seamless performance. Their support was crucial in our Kickstarter success and future expansion."',
    author: "James Loudon",
    role: "Founder, CEO, Campaigns Never Die",
    authorProfilePic: "/images/testimonials/image_2.jpg",
  },
  {
    id: 2,
    quote:
      '"Datapixl helped Clinvvo scale Al-driven healthcare by optimizing workflows and building a CoE in India. Their expertise cut costs by 40%, boosted patient satisfaction by 50%, and enabled us to serve over 1M users in a year, driving smarter, more efficient care."',
    author: "Olle Andreasson",
    role: "Co-founder, CMO, Clinvvo",
    authorProfilePic: "/images/testimonials/image_3.jpg",
  },
  {
    id: 3,
    quote:
      "\"Partnering with Datapixl has been a game changer for Barkfors. Their strategic guidance helped us develop a future proof, AI ready product strategy that meets diverse customer needs while ensuring scalability across all cloud environments. Thanks to their expertise, we're now positioned to build next-gen products that drive growth and align with broader product and Al vision.\"",
    author: "Jesper Tuner",
    role: "CEO, Barkfors AB",
    authorProfilePic: "/images/testimonials/image_4.jpeg",
  },
];
